import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { router } from './app/router';
import { useAuth } from './lib/auth-store';
import { fetchMe } from './api/auth';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000 } },
});

export function App() {
  const [booted, setBooted] = useState(false);

  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const res = await fetch('/auth/refresh', { method: 'POST', credentials: 'include' });
        if (res.ok) {
          const body = (await res.json()) as { access_token?: unknown };
          if (typeof body.access_token !== 'string') throw new Error('invalid refresh response');
          const access_token = body.access_token;
          if (ignore) return;
          useAuth.setState({ accessToken: access_token });
          const me = await fetchMe();
          if (ignore) return;
          useAuth.getState().setSession({ accessToken: access_token, user: me.user, tenant: me.tenant });
        }
      } catch { /* not logged in or bad response */ }
      if (!ignore) setBooted(true);
    })();
    return () => { ignore = true; };
  }, []);

  if (!booted) {
    return <div style={{ display: 'grid', placeItems: 'center', height: '100%', color: '#64748b' }}>Loading…</div>;
  }
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
